import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Teleport } from "vue";
import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'overlay-content',
  props: {
    modifires: { type: [String, Array, Boolean] }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(mapModifires)('overlay-content', _ctx.modifires))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})